import { Component, computed, input, signal } from '@angular/core';

import { FontIconComponent } from '@camelot/icons';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent, LinkComponent, TextComponent } from '@camelot/ui';

import { FiltersTagComponent } from '../../../filters/tag/filters-tag.component';
import { ActiveFilterTag } from '../../../filters/types';
import { CamTranslationGrid } from '../../translation.service';
import { AbstractGridComponent } from '../abstract-grid.component';

@Component({
  imports: [BadgeComponent, FiltersTagComponent, FontIconComponent, LinkComponent, TextComponent, TranslatePipe],
  selector: 'cam-grid-tag',
  styleUrl: './grid-tag.component.scss',
  templateUrl: './grid-tag.component.html',
})
export class GridTagComponent extends AbstractGridComponent<any> {
  constructor() {
    super();
    CamTranslationGrid.getInstance();
  }

  showResultCount = input(false);

  public readonly totalRows = computed(() => this._grid.rowCount());

  public readonly tagsList = signal<
    {
      key: string;
      values: ActiveFilterTag[];
    }[]
  >([]);

  override ngOnInit() {
    super.ngOnInit();
    this._registerSubscription(
      this._grid.filters.filtersChanged$.subscribe(() => this.tagsList.set(this._grid.getTags()))
    );
    this.tagsList.set(this._grid.getTags());
  }

  // `applySearch` alimente `filters.searchText`, jamais le quick filter d'ag-grid : le badge y lisait du vide.
  public searchTerm(): string | null {
    return this._grid.filters.searchText || null;
  }

  public removeSearch() {
    this._grid.filters.applySearch('');
  }
  public removedFilter = (value: ActiveFilterTag) => {
    this._grid.removeTag(value);
  };

  public reset() {
    this._grid.filters.resetFilters();
  }
}
